import React, {useEffect, useState} from 'react';
import '../styling/containerStyles.css'
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Label from '../components/label';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ButtonComp from '../components/button';
// import paytmLogo from '../assets/images/paytmLogo.png';
// import bankLogo from '../assets/images/bankLogo.png';
// import fccPointsLogo from '../assets/images/fccPointsLogo.png';
// import paytmLogo from '../assets/images/paytmLogo.svg';
import bankLogo from '../assets/images/bankLogo.svg';
import fccPointsLogo from '../assets/images/fccPointsLogo.svg';
// import pidiliteBlueLogo from '../assets/images/pidiliteBlueLogo.png';
// import saathiLogo from '../assets/images/saathiLogo.png';
// import feviSealLogo from '../assets/images/feviSealLogo.png';
import leftChevron from '../assets/images/leftChevron.svg';
import rupessIcon from '../assets/images/rupessIcon.svg';
import pointIcon from '../assets/images/pointIcon.svg';
import QRBarcodeScanner from '../components/QRBarcodeScanner';
// import pidiliteTopBanner from '../assets/images/pidiliteTopBanner2.png';
import { MaxCountResponse } from './main';


interface TransactionDetailsProps{
    amount:string;
    redeemPoints: boolean;
    conversions: Array<any>;
    handleToProceed:Function;
    userType: string;
    banner: any;
    maxLimitCounts: MaxCountResponse;
    handleToGetMaxLimitCounts: Function;
    checkCouponCode: (code: string) => Promise<{ valid: boolean; data?: any; message?: string }>;
    initialCouponCode?: string;
    processSingleCouponTransaction?: (couponCode: string, amount: string, paymentType: string) => Promise<void>;
    brand: string;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = (props: TransactionDetailsProps) =>{

    const{
        handleToProceed, amount, redeemPoints, conversions, userType, banner, maxLimitCounts, handleToGetMaxLimitCounts, checkCouponCode, initialCouponCode, processSingleCouponTransaction, brand
    } = props;
    const [value, setValue] = useState('')
    const [amt, setAmt] = useState('')
    const [scannerOpen, setScannerOpen] = useState(false)
    const [scannedCoupons, setScannedCoupons] = useState<Array<{ code: string; data: any; points: string; amount: string; brand?: string }>>([])
    const [isRedeemPoints, setIsRedeemPoints] = useState(redeemPoints);
    // const user = userType === 'FCC'? 'FCC' : 'CWC';
    const user = userType;
    const redeemableAmt = parseFloat(amount || '0');
    
    const wallet = String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))
    const bank =   String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))
    const points = String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))
    const p_to_r = String((redeemableAmt*parseFloat(conversions[3])).toFixed(2))
    const c0 = parseFloat(conversions[0] || '0');
    const c1 = parseFloat(conversions[1] || '0');
    const c2 = parseFloat(conversions[2] || '0');
    const c3 = parseFloat(conversions[3] || '0');
    const [totalPoints, setTotalPoints] = useState(0);
    const [totalBank, setTotalBank] = useState(0);
    const [totalPtoR, setTotalPtoR] = useState(0);

    useEffect(() => {
        if(scannedCoupons.length > 0 && redeemPoints){
            const isWoodgrip = scannedCoupons.some(coupon => coupon.brand === 'woodgrip');
            if(isWoodgrip){
                setValue('');
                setIsRedeemPoints(false);
            }else{
                setIsRedeemPoints(true);
            }
        }else{
            setIsRedeemPoints(redeemPoints);
        }
    }, [scannedCoupons,redeemPoints]);
    useEffect(() => {
        let pointsSum = 0;
        let bankSum = 0;
        let paytmSum = 0;
        let ptoRSum = 0;

        scannedCoupons.forEach(coupon => {
            const couponCodePoint = parseFloat(coupon.data?.codePoint || '0');
            if (!couponCodePoint || isNaN(couponCodePoint)) return;

            pointsSum += couponCodePoint * parseFloat(conversions[2] || '0');
            bankSum   += couponCodePoint * parseFloat(conversions[1] || '0');
            paytmSum  += couponCodePoint * parseFloat(conversions[0] || '0');
            ptoRSum   += couponCodePoint * parseFloat(conversions[3] || '0');
        });

        setTotalPoints(Number(pointsSum.toFixed(2)));
        setTotalBank(Number(bankSum.toFixed(2)));
        setTotalPtoR(Number(ptoRSum.toFixed(2)));
    }, [redeemableAmt, c0, c1, c2, c3, scannedCoupons, conversions]);

    let remainingAttempts = Number.POSITIVE_INFINITY;
    let remainingAmount = Number.POSITIVE_INFINITY;
    let scanMoreLabel = 'Scan more';
    let canScanMore = true;
    let scanMoreHelperText = '';

    const hasRealLimits =
      maxLimitCounts &&
      typeof (maxLimitCounts as any).max === 'number' &&
      ((maxLimitCounts as any).max as number) > 0;

    if (hasRealLimits) {
      const { max, ...brands } = maxLimitCounts as any;
      const maxCount = max as number;

      // Helper to map any brand string to one of the server buckets (e.g. "woodgrip" or "other")
      const brandKeys = Object.keys(brands);
      const resolveBucketKey = (rawBrand: string | undefined): string => {
        const normalized = (rawBrand || '').trim().toLowerCase();
        if (!normalized) {
          return 'other';
        }

        // 1) Exact match
        let match = brandKeys.find(key => key.trim().toLowerCase() === normalized);
        if (match) {
          return match;
        }

        // 2) Substring match (e.g. "woodgrip-popular" -> "woodgrip")
        match = brandKeys.find(key => normalized.includes(key.trim().toLowerCase()));
        return match || 'other';
      };

      // Global usage across ALL brands for attempt count
      const hasInitialInArray =
        !!initialCouponCode &&
        scannedCoupons.some(c => c.code === initialCouponCode);

      const initialCount = initialCouponCode && !hasInitialInArray ? 1 : 0;
      const usedCount = initialCount + scannedCoupons.length;

      const globalRem = maxCount - usedCount;
      remainingAttempts = globalRem;

      // Brand bucket for the current product (screen)
      const pageBucketKey = resolveBucketKey(brand);
      const brandLimits = (brands as any)[pageBucketKey] || (brands as any).other;

      // Brand‑specific redeemed amount (only coupons in the same bucket as this screen)
      if (brandLimits && typeof brandLimits.remaining_amount === 'number') {
        let redeemedForBrand = 0;
        scannedCoupons.forEach(coupon => {
          const bucketKey = resolveBucketKey(coupon.brand || brand);
          if (bucketKey !== pageBucketKey) return;

          const couponCodePoint = parseFloat(coupon.data?.codePoint || '0');
          if (!couponCodePoint || isNaN(couponCodePoint)) return;

          redeemedForBrand += couponCodePoint * (parseFloat(conversions[3] || '0'));
        });

        remainingAmount = brandLimits.remaining_amount - redeemedForBrand;
      }

      const rem = Math.max(globalRem, 0);
      const remAmount = Math.max(remainingAmount, 0);

      // Disable only when we hit either global scan count OR brand‑specific amount limit
      canScanMore = rem > 0 && remAmount > 0;

      if (!canScanMore) {
        if (rem <= 0 && remAmount <= 0) {
          scanMoreLabel = 'Scan limit reached';
          scanMoreHelperText =
            `You have used all ${maxCount} scans and the full redeemable amount for today.`;
        } else if (rem <= 0) {
          scanMoreLabel = 'Scan limit reached';
          scanMoreHelperText =
            `You have already scanned the maximum of ${maxCount} coupons for today.`;
        } else if (remAmount <= 0) {
          scanMoreLabel = 'Amount limit reached';
          scanMoreHelperText = 'You have reached the maximum redeemable amount for today.';
        }
      } else {
        if (usedCount === 0) {
          scanMoreLabel = `Scan coupons (up to ${maxCount})`;
          scanMoreHelperText = '';
        } else {
          scanMoreLabel = `Scan more coupons (${rem} remaining)`;
          scanMoreHelperText =
            `You can scan ${rem} more coupon${rem === 1 ? '' : 's'} today `
            + `(amount left: ₹${remAmount.toFixed(2)}).`;
        }
      }
    }
    
    const handleClick = async (option: any) => {
        if(option === 'GoBack'){
            handleToProceed(option)
            return;
        }

        if (!value) return; 
        if(scannedCoupons.length === 0){
            handleToProceed(value, amt, 'type', '');
            return;
        }
        const couponsToProcess: Array<{ code: string; amount: string, points: string, brand: string }> = [];

        scannedCoupons.forEach(coupon => {
            const couponCodePoint = parseFloat(coupon.data?.codePoint || '0');
            let couponAmount = '';
            let couponPoint = '';
            if (value === 'bankAccount') {
                couponAmount = String((couponCodePoint * parseFloat(conversions[1])).toFixed(2));
            } else if (value === 'fccPoints') {
                couponAmount = String((couponCodePoint * parseFloat(conversions[2])).toFixed(2));
            } else if (value === 'paytm') {
                couponAmount = String((couponCodePoint * parseFloat(conversions[0])).toFixed(2));
            }   
            if (couponAmount || couponPoint) {
                couponsToProcess.push({
                    code: coupon.code,
                    amount: couponAmount,
                    points: couponPoint,
                    brand: coupon.brand || brand,
                });
            }
        });
        handleToProceed(value, amt, 'type', couponsToProcess);
    }

    const handleScanMoreClick = async (arg: any) => {
        setScannerOpen(true);
    }
    
    const handleRadioChange = (event: any) => {
        let val = event.target.value;
        setValue(val)
        
        if(val === 'paytm'){            
            setAmt(wallet)
        }
        else if( val === 'bankAccount'){
            setAmt(bank)
        }
        else if(val === 'fccPoints'){
            setAmt(points)
        }
    };

    const handleScanSuccess = (scannedCode: string, couponData?: any, couponBrand?: string) => {
        if (couponData) {
            setScannedCoupons(prev => {
                const next = [...prev];
                if (next.length === 0 && initialCouponCode && amount) {
                    next.push({
                        code: initialCouponCode,
                        points: p_to_r,
                        amount: amount,
                        data: { codePoint: amount }, 
                        brand: brand,               
                    });
                }
                next.push({
                    code: scannedCode,
                    data: couponData,
                    points: '',
                    amount: '',
                    brand: couponBrand || brand,
                });

                return next;
            });
        }
        setScannerOpen(false);
    };

    const handleCloseScanner = () => {
        setScannerOpen(false);
    };

        return (
            <div className='homeWrap'>
                <div className='homeTop'>
                    {/* <div className='homeTopInner'>
                        <img src={pidiliteBlueLogo} alt='Pidilite Blue Logo' className='pidiliteLogo'/>
                        <img src={saathiLogo} alt='Saathi Logo' className='saathiLogo'/>
                        <div className='productLogoWrap'>
                            <img src={feviSealLogo} alt='Product Logo' className='productLogo'/>
                        </div>
                    </div> */}
                    <div className='homeTopBanner'>
                        <img src={banner} alt='Pidilite Top Banner' className='pidiliteTopBanner'/>
                    </div>
                </div>
                <div className='transactionDetails'>
                    <div className='buttonAndLabel'>
                        <Button  className='goBack back-btn' 
                        // onClick={() => {handleToProceed('GoBack')}}
                         >
                            {/* <ArrowBackIosIcon /> */}
                            <img src={leftChevron} alt='Left Chevron' className='leftChevron'/>
                        </Button>
                        <Label content='Transaction Details' />
                    </div>
                    {/* <br></br> */}
                    <div className='sideText'>Choose your method of transaction below</div>    

                    <div className='creditValueWrap'>
                        <div className='creditValueWrapInner'>
                            <p className='creditValueText'>Credit Value</p>  
                            <div className='creditValueRupessWrap'>
                                <img src={rupessIcon} alt='Rupess Icon' className='rupessIcon'/> 
                                <p>{totalPtoR ? totalPtoR : p_to_r}</p>
                            </div>
                            <div className='creditValuePointsWrap'>
                                <img src={pointIcon} alt='Point Icon' className='pointIcon'/> 
                                <p>{totalPoints ? totalPoints : points} Pts</p>
                            </div>
                        </div>
                    </div>                
                    
                    {!isRedeemPoints &&
                    <div>
                        <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                            {/* <FormControlLabel value="paytm" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Paytm Wallet  ({"₹ " + wallet})</div>
                                        <div className='paySubName'>Use this option if you are a registered user of Paytm</div>
                                    </div>
                                </section>
                            }
                            /> <br></br>  */}
                            <FormControlLabel value="bankAccount" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Bank Account  ({"₹ " + (totalBank ? totalBank : String((redeemableAmt*parseFloat(conversions[1])).toFixed(2)))})</div>
                                        {scannedCoupons.length > 0 && (
                            <ul className='transaction-details-list'>
                                {[...scannedCoupons].reverse().map((coupon, index) => {
                                    const couponCodePoint = parseFloat(coupon.data?.codePoint || '0');
                                    const couponBank = couponCodePoint * parseFloat(conversions[1]);
                                    return (
                                        <li key={index}>
                                            <div className='transaction-details-item'>
                                                {coupon.code} <span className='transaction-details-item-points'>( ₹{couponBank.toFixed(2)} )</span>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                                        <div className='paySubName'>Use this option if you wish to get the amount in your bank account</div>
                                    </div>
                            </section>
                            } /> <br></br>
                            </RadioGroup>
                    </div>
                    }
                    {isRedeemPoints && 
                    <div>
                        
                        <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                            {/* <FormControlLabel value="paytm" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Paytm Wallet  ({"₹ " + wallet})</div>
                                        <div className='paySubName'>Use this option if you are a registered user of Paytm</div>
                                    </div>
                                </section>
                            }
                            /> <br></br>  */}
                            <FormControlLabel value="bankAccount" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Bank Account  (₹  {totalBank ? totalBank : String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))})</div>
                                        {scannedCoupons.length > 0 && (
                            <ul className='transaction-details-list'>
                                {[...scannedCoupons].reverse().map((coupon, index) => {
                                    const couponCodePoint = parseFloat(coupon.data?.codePoint || '0');
                                    const couponBank = couponCodePoint * parseFloat(conversions[1]);
                                    return (
                                        <li key={index}>
                                            <div className='transaction-details-item'>
                                                {coupon.code} <span className='transaction-details-item-points'>( ₹{couponBank.toFixed(2)} )</span>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                                        <div className='paySubName'>Use this option if you wish to get the amount in your bank account</div>
                                    </div>
                            </section>
                            } /> <br></br>
                            <FormControlLabel value="fccPoints" control={<Radio />} label={<section className='menuItem'>
                                    <img className='payLogo' src = {fccPointsLogo} alt='FCC points' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>{user} Points ({totalPoints ? totalPoints : points + " Points"}/₹ {totalPtoR ? totalPtoR : p_to_r})</div>
                                        {scannedCoupons.length > 0 && (
                            <ul className='transaction-details-list'>
                                {[...scannedCoupons].reverse().map((coupon, index) => {
                                    const couponCodePoint = parseFloat(coupon.data?.codePoint || '0');
                                    const couponBank = couponCodePoint * parseFloat(conversions[2]);
                                    return (
                                        <li key={index}>
                                            <div className='transaction-details-item'>
                                                {coupon.code} <span className='transaction-details-item-points'>({couponBank.toFixed(2)} )</span>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                                        <div className='paySubName'>Use this option if you wish to redeem the coupon in the form of FCCR points</div>
                                    </div>
                            </section>} /> <br></br>
                        </RadioGroup>
                    </div>
                    }
                
                    <div className='transaction-details-actions'>
                        <ButtonComp label= {'Proceed'} 
                                        name={'PROCEED'} 
                                        visible={true}
                                        handleToUpdate={handleClick}  />
                        <ButtonComp 
                            label={scanMoreLabel}
                            name={scanMoreLabel} 
                            visible={true}
                            disabled={!canScanMore}
                            handleToUpdate={handleScanMoreClick}
                        />
                    </div>
                    {!canScanMore && (
                    <div className='scan-more-helper-text'>
                        {scanMoreHelperText}
                    </div>
                    )}
                    <QRBarcodeScanner
                        open={scannerOpen}
                        onClose={handleCloseScanner}
                        onScanSuccess={handleScanSuccess}
                        checkCouponCode={checkCouponCode}
                        maxLimitCounts={maxLimitCounts}
                        scannedCoupons={scannedCoupons}
                        totalPtoR={totalPtoR}
                        ptoRFactor={c3}
                        brand={brand}
                        initialCouponCode={initialCouponCode}
                    />
                    </div>
            </div>         
        )
    }


export default TransactionDetails